'use strict';
const angular = require('angular');
import DailyReportReviewController from './dailyReportReview.controller';
import routes from './dailyReportReview.routes';

export default angular.module('nomasvelloDashboardApp.dailyReportReview', [
])
    .config(routes)
    .controller('DailyReportReviewController', DailyReportReviewController)
    .name;



// WEBPACK FOOTER //
// ./client/app/manager/dailyReportReview/index.ts